module.exports = __webpack_public_path__ + "static/media/Desktop_Skills_17.d5e67140.png";